import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface RoadTypeParams extends DefaultHttpHeaders {
  /** Unique identifier of road type */
  roadTypeCode: string;
}

@Injectable()
export class RoadTypeService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining Q&B road type by code
   * Service for obtaining Q&B road type by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundRoadTypeById
   */
  roadType(params: RoadTypeParams): Observable<ParameterResult> {
    const pathParams = {
      roadTypeCode: params.roadTypeCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/roadType/${pathParams.roadTypeCode}`,
    });
  }
}
